/**
 * Simple Cart Drawer Fix - No Overlay Version
 */
(function() {
  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function() {
    // Update cart count
    function updateCartCount() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const itemCount = cart.item_count || 0;
          document.querySelectorAll('#cart-icon-bubble, a[href="/cart"]').forEach(link => {
            if (link.querySelector('.cart-count')) {
              link.querySelector('.cart-count').textContent = `(${itemCount})`;
            } else {
              link.textContent = `Cart (${itemCount})`;
            }
          });
        })
        .catch(error => console.error('Error fetching cart:', error));
    }
    
    // Run once on page load
    updateCartCount();
    
    // Function to handle cart drawer opening/closing
    function setupCartDrawer() {
      // Target cart links
      const cartLinks = document.querySelectorAll('a[href="/cart"], #cart-icon-bubble');
      
      cartLinks.forEach(link => {
        link.addEventListener('click', function() {
          setTimeout(function() {
            // EXTREMELY SPECIFIC TARGETING FOR THE HEADER ELEMENTS
            const stickyHeader = document.querySelector('sticky-header');
            if (stickyHeader) {
              stickyHeader.style.setProperty('z-index', '50', 'important');
            }
            
            const header = document.querySelector('sticky-header .header');
            if (header) {
              header.style.setProperty('z-index', '50', 'important');
            }
            
            // Set ultra-high z-index for cart drawer
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              cartDrawer.style.setProperty('z-index', '99999999', 'important');
              
              // Remove/hide the overlay
              const overlay = cartDrawer.querySelector('.cart-drawer__overlay');
              if (overlay) {
                overlay.style.setProperty('display', 'none', 'important');
                overlay.style.setProperty('visibility', 'hidden', 'important');
                overlay.style.setProperty('opacity', '0', 'important');
                overlay.style.setProperty('pointer-events', 'none', 'important');
              }
              
              // Ensure drawer content is visible and interactive
              const content = cartDrawer.querySelector('.cart-drawer__content');
              if (content) {
                content.style.setProperty('z-index', '99999999', 'important');
                content.style.setProperty('display', 'block', 'important');
                content.style.setProperty('visibility', 'visible', 'important');
                content.style.setProperty('position', 'fixed', 'important');
                content.style.setProperty('top', '0', 'important');
                content.style.setProperty('right', '0', 'important');
                content.style.setProperty('bottom', '0', 'important');
                content.style.setProperty('width', '420px', 'important');
                content.style.setProperty('max-width', '100vw', 'important');
                content.style.setProperty('height', '100%', 'important');
                content.style.setProperty('background', 'white', 'important');
                content.style.setProperty('pointer-events', 'auto', 'important');
                content.style.setProperty('overflow-y', 'auto', 'important');
                content.style.setProperty('box-shadow', '-5px 0 15px rgba(0,0,0,0.1)', 'important');
              }
            }
          }, 10);
        });
      });
      
      // Also watch for attribute changes on the cart-drawer
      if (document.querySelector('cart-drawer')) {
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.attributeName === 'open') {
              const cartDrawer = mutation.target;
              if (cartDrawer.hasAttribute('open')) {
                // Force the header behind
                const stickyHeader = document.querySelector('sticky-header');
                if (stickyHeader) {
                  stickyHeader.style.setProperty('z-index', '50', 'important');
                }
                
                const header = document.querySelector('sticky-header .header');
                if (header) {
                  header.style.setProperty('z-index', '50', 'important');
                }
                
                // Set cart drawer ultra-high
                cartDrawer.style.setProperty('z-index', '99999999', 'important');
                
                // Remove/hide the overlay
                const overlay = cartDrawer.querySelector('.cart-drawer__overlay');
                if (overlay) {
                  overlay.style.setProperty('display', 'none', 'important');
                  overlay.style.setProperty('visibility', 'hidden', 'important');
                  overlay.style.setProperty('opacity', '0', 'important');
                  overlay.style.setProperty('pointer-events', 'none', 'important');
                }
                
                // Ensure drawer content is visible and interactive
                const content = cartDrawer.querySelector('.cart-drawer__content');
                if (content) {
                  content.style.setProperty('z-index', '99999999', 'important');
                  content.style.setProperty('display', 'block', 'important');
                  content.style.setProperty('visibility', 'visible', 'important');
                  content.style.setProperty('position', 'fixed', 'important');
                  content.style.setProperty('top', '0', 'important');
                  content.style.setProperty('right', '0', 'important');
                  content.style.setProperty('bottom', '0', 'important');
                  content.style.setProperty('width', '420px', 'important');
                  content.style.setProperty('max-width', '100vw', 'important');
                  content.style.setProperty('height', '100%', 'important');
                  content.style.setProperty('background', 'white', 'important');
                  content.style.setProperty('pointer-events', 'auto', 'important');
                  content.style.setProperty('overflow-y', 'auto', 'important');
                  content.style.setProperty('box-shadow', '-5px 0 15px rgba(0,0,0,0.1)', 'important');
                }
              } else {
                // Restore header z-index when drawer closes
                const stickyHeader = document.querySelector('sticky-header');
                if (stickyHeader) {
                  // Restore the original z-index
                  stickyHeader.style.setProperty('z-index', '500', 'important');
                }
                
                const header = document.querySelector('sticky-header .header');
                if (header) {
                  header.style.setProperty('z-index', '500', 'important');
                }
              }
            }
          });
        });
        
        document.querySelectorAll('cart-drawer').forEach(drawer => {
          observer.observe(drawer, { attributes: true });
        });
        
        // Add click event to close cart when clicking outside
        document.addEventListener('click', function(e) {
          const cartDrawer = document.querySelector('cart-drawer[open]');
          const cartContent = document.querySelector('cart-drawer[open] .cart-drawer__content');
          
          // Check if drawer is open and click is outside the drawer
          if (cartDrawer && cartContent && !cartContent.contains(e.target) && 
              !e.target.closest('#cart-icon-bubble') && !e.target.closest('a[href="/cart"]')) {
            cartDrawer.removeAttribute('open');
          }
        });
      }
    }
    
    // Initialize cart drawer functionality
    setupCartDrawer();
  });
})();